export const isActiveStyles="text-xl text-purple-800 font-bold hover:text-purple-900 duration-100 transition-all ease-in-out";
export const isNotActiveStyles="text-xl text-purple-800 font-semibold hover:text-purple-900 duration-100 transition-all ease-in-out"
export const bgColors=[
    "#E9E2FF",
    "#FAE2FF",
    "#FFE2E6",
    "#E2FFE9",
    "#FFFFE2",
]